export const activityLogSelectors = {
  gridData: (state) => state.gridData,
  item: (state) => state.item,
  update: (state) => state.update,
}
